module.exports = __webpack_public_path__ + "static/img/frontal.3cb530f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontal.png
// module id = 3bRx
// module chunks = 3